export const VALID_PRODUCT_CATEGORIES_WITH_PURPOSE = ['investing', 'cash', 'bond_investing', 'retirement'] as const;
export type ProductCategory = (typeof VALID_PRODUCT_CATEGORIES_WITH_PURPOSE)[number];
